module.exports = __webpack_public_path__ + "img/registration_at.47796ff5.svg";